export const ROLE_FILTERS = ['All', 'Admin', 'User', 'Approver', 'Leader'] as const;

export type RoleFilter = typeof ROLE_FILTERS[number];

// Distinct from ROLE_FILTERS (Master Panel users tab): splits Admin/Executive
// admin and renames User to Member.
export const USER_ROLE_FILTERS = [
  'All users',
  'Leader',
  'Member',
  'Approver',
  'Admin',
  'Executive admin',
] as const;

export type UserRoleFilter = typeof USER_ROLE_FILTERS[number];
